<template>
  <div>
    <v-toolbar v-if="!screenIsWideEnough" flat class="transparent">
      <v-toolbar-title>Advanced Search</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click.native.stop="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card class="pa-3 transparent" flat>
      <v-card-title v-if="screenIsWideEnough">
        <div class="title">Advanced Search</div>
      </v-card-title>

      <v-layout wrap>
        <v-flex class="mr-2">
          <v-layout column>
            <v-subheader>Dates</v-subheader>
            <v-menu
              ref="fromMenu"
              v-model="showStartDatePicker"
              transition="scale-transition"
              :close-on-content-click="false"
              offset-y
              :return-value.sync="startDate"
              class="ml-3"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="Start date"
                  v-model="prettyStartDate"
                  prepend-inner-icon="event"
                  readonly
                  filled
                  hide-details
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                no-title
                scrollable
                min="2016-05-01"
                :max="new Date().toISOString().substr(0, 10)"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="showStartDatePicker = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.fromMenu.save(startDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>
            <v-menu
              ref="toMenu"
              v-model="showEndDatePicker"
              transition="scale-transition"
              :close-on-content-click="false"
              offset-y
              :return-value.sync="endDate"
              class="ml-3"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="End date"
                  v-model="prettyEndDate"
                  prepend-inner-icon="event"
                  readonly
                  filled
                  hide-details
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                no-title
                scrollable
                :min="startDate"
                :max="new Date().toISOString().substr(0, 10)"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="showEndDatePicker = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.toMenu.save(endDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-layout>
        </v-flex>

        <v-flex>
          <v-layout column>
            <v-subheader>
              Funding Amount
            </v-subheader>
            <v-text-field
              flat
              label="Funding minimum"
              v-model="fundingMinimum"
              filled
              hide-details
              prepend-inner-icon="mdi-currency-gbp"
              class="ml-3"
            ></v-text-field>
            <v-text-field
              flat
              label="Funding maximum"
              v-model="fundingMaximum"
              filled
              hide-details
              prepend-inner-icon="mdi-currency-gbp"
              class="ml-3"
              id="maxFunding"
            ></v-text-field>
          </v-layout>
        </v-flex>

        <v-flex xs12 v-if="UserHasRole('Platform') || UserHasRole('Call Centre')">
          <v-autocomplete
            :items="referrers"
            item-text="name"
            return-object
            v-model="referrerAccountId"
            clearable
            placeholder="Referrer"
            dense
            class="ml-3"
          ></v-autocomplete>
          <v-select
            :items="referrerTypes"
            item-text="name"
            item-value="type"
            v-model="referrerType"
            placeholder="Referrer Type"
            clearable
            dense
            class="ml-3"
          ></v-select>
        </v-flex>
      </v-layout>

      <v-divider class="mt-4"></v-divider>

      <v-layout wrap>
        <v-flex xs4>
          <v-list subheader dense class="transparent">
            <v-subheader>Filters</v-subheader>
            <abf-filter-item
              :active="ReferralPageFilters.eliteReferrer"
              icon="fad fa-medal"
              @click="toggleFilter('eliteReferrer')"
              v-if="UserHasRole('Platform') || UserHasRole('Call Centre')"
              >Elite Referrer
            </abf-filter-item>

            <abf-filter-item
              :active="ReferralPageFilters.noEmail"
              icon="fad fa-envelope"
              @click="toggleFilter('noEmail', 'withEmail')"
              v-if="!UserHasRole('Partner')"
              >No Email
            </abf-filter-item>

            <abf-filter-item
              :active="ReferralPageFilters.withEmail"
              icon="fad fa-envelope"
              @click="toggleFilter('withEmail', 'noEmail')"
              v-if="!UserHasRole('Partner')"
            >With Email
            </abf-filter-item>

            <abf-filter-item
              :active="ReferralPageFilters.withPhone"
              icon="fad fa-phone"
              @click="toggleFilter('withPhone', 'noPhone')"
              v-if="!UserHasRole('Partner')"
            >With Telephone
            </abf-filter-item>

            <abf-filter-item
              :active="ReferralPageFilters.noPhone"
              icon="fad fa-phone"
              @click="toggleFilter('noPhone', 'withPhone')"
              v-if="!UserHasRole('Partner')"
            >No Telephone
            </abf-filter-item>

            <abf-filter-item
              :active="ReferralPageFilters.closed"
              icon="fad fa-times"
              @click="toggleFilter('closed', 'open')"
              v-if="!UserHasRole('Partner')"
              >Closed
            </abf-filter-item>
            <abf-filter-item
              :active="ReferralPageFilters.open"
              icon="fad fa-folder-open"
              @click="toggleFilter('open', 'closed')"
              v-if="!UserHasRole('Partner')"
            >Open
            </abf-filter-item>

            <abf-filter-item
              :active="ReferralPageFilters.bool.toBeCalled"
              icon="fad fa-phone-plus"
              @click="toggleFilter('bool.toBeCalled')"
              v-if="!UserHasRole('Partner')"
              >To be called
            </abf-filter-item>

            <abf-filter-item
              :active="ReferralPageFilters.registered"
              icon="fad fa-user"
              @click="toggleFilter('registered', 'notRegistered')"
              >Registered
            </abf-filter-item>

            <abf-filter-item
              :active="ReferralPageFilters.notRegistered"
              icon="fad fa-user-slash"
              @click="toggleFilter('notRegistered', 'registered')"
              >Not Registered
            </abf-filter-item>

            <abf-filter-item
              :active="ReferralPageFilters.questionsComplete"
              @click="toggleFilter('questionsComplete', 'questionsIncomplete')"
            >
              <v-progress-circular
                :rotate="-90"
                :size="28"
                :width="2"
                :value="100"
                :color="ReferralPageFilters.questionsComplete ? 'accent' : 'grey'"
                slot="icon"
              >
                100
              </v-progress-circular>
              Questions Complete
            </abf-filter-item>

            <abf-filter-item
              :active="ReferralPageFilters.questionsIncomplete"
              @click="toggleFilter('questionsIncomplete', 'questionsComplete')"
            >
              <v-progress-circular
                :rotate="-90"
                :size="28"
                :width="2"
                :value="0"
                :color="ReferralPageFilters.questionsIncomplete ? 'accent' : 'grey'"
                slot="icon"
              >
                0
              </v-progress-circular>
              Questions Incomplete
            </abf-filter-item>

            <abf-filter-item
              :active="ReferralPageFilters.autoSendEnquiries"
              icon="fad fa-shipping-fast"
              @click="toggleFilter('autoSendEnquiries', 'notAutoSendEnquiries')"
              v-if="!UserHasRole('Broker')"
              >Auto send enquiries
            </abf-filter-item>

            <abf-filter-item
              :active="ReferralPageFilters.notAutoSendEnquiries"
              icon="fad fa-truck"
              @click="toggleFilter('notAutoSendEnquiries', 'autoSendEnquiries')"
              v-if="!UserHasRole('Broker')"
            >Not auto send enquiries
            </abf-filter-item>

            <abf-filter-item
              :active="ReferralPageFilters.noEnquiries"
              icon="fad fa-comment-alt-slash"
              @click="toggleFilter('noEnquiries')"
              >No enquiries
            </abf-filter-item>
          </v-list>
        </v-flex>
        <v-flex xs4>
          <v-list dense subheader class="transparent">
            <v-subheader>Enquiry Statuses</v-subheader>
            <v-list-item
              v-for="status in orderedStatuses"
              :key="status.id"
              @click="toggleEnquiryStatusFilter(status)"
              :color="ReferralPageFilters.enquiryStatuses.includes(status.id) ? 'accent darken-1' : 'grey darken-2'"
            >
              <v-list-item-action style="min-width: 42px;">
                <v-checkbox
                  readonly
                  :input-value="ReferralPageFilters.enquiryStatuses.includes(status.id)"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ status.name | titleCase }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-flex>
        <v-flex xs4 v-if="!UserHasRole('Partner') && !UserHasRole('Broker')">
          <v-list dense subheader class="transparent">
            <v-subheader>Owners</v-subheader>
            <v-list-item
              v-for="owner in orderedOwners"
              :key="owner.id"
              @click="toggleOwnerFilter(owner)"
              :color="ReferralPageFilters.owners.includes(owner.id) ? 'accent darken-1' : 'grey darken-2'"
            >
              <v-list-item-action style="min-width: 50px;">
                <v-avatar size="33">
                  <abf-owner-avatar :user="owner"></abf-owner-avatar>
                </v-avatar>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title :class="{ selected: ReferralPageFilters.owners.includes(owner.id) }"
                  >{{ owner.full_name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import debounce from 'lodash/debounce';
import isNull from 'lodash/isNull';
import orderBy from 'lodash/orderBy';
import words from 'lodash/words';
import capitalize from 'lodash/capitalize';
import { DateTime } from 'luxon';
import AbfFilterItem from '@/components/Abf/Filters/AbfFilterItem';
import AbfOwnerAvatar from '@/components/Abf/AbfOwnerAvatar';

export default {
  name: 'ReferralFilters',
  components: { AbfFilterItem, AbfOwnerAvatar },
  data: () => ({
    showStartDatePicker: false,
    showEndDatePicker: false,
    referrerTypes: [
      { type: 'bank', name: 'Bank' },
      { type: 'broker', name: 'Broker' },
      { type: 'provider', name: 'Funder' },
      { type: 'partner', name: 'Partner' }
    ]
  }),
  computed: {
    ...mapGetters(['ReferralPageFilters', 'RegistrationReferrerList', 'EnquiryStatuses', 'OwnersList', 'UserHasRole']),
    referrerAccountId: {
      get() {
        return this.ReferralPageFilters.referrer;
      },
      set(referrer = null) {
        this.setReferralFilters({ referrer });
      }
    },
    referrerType: {
      get() {
        return this.ReferralPageFilters.referrerType;
      },
      set(referrerType = null) {
        this.setReferralFilters({ referrerType });
      }
    },
    referrers() {
      return this.RegistrationReferrerList.slice(0).sort((a, b) => a.name.localeCompare(b.name));
    },
    fundingMinimum: {
      get() {
        return this.currency(String(this.ReferralPageFilters.funding.minimum));
      },
      set: debounce(function(amount) {
        amount = parseInt(amount.replace(/,/g, '')) || 0;

        this.setReferralPageFundingMinimum(amount).then(() => {
          this.$emit('change');
        });
      }, 500)
    },
    fundingMaximum: {
      get() {
        return this.currency(this.ReferralPageFilters.funding.maximum);
      },
      set: debounce(function(amount) {
        amount = parseInt(amount.replace(/,/g, ''));
        if (amount > 50000000) {
          document.getElementById('maxFunding').value = this.currency(50000000);
        } else if (amount > parseInt(this.fundingMinimum.toString().replace(/,/g, ''))) {
          this.setReferralPageFundingMaximum(amount).then(() => {
            this.$emit('change');
          });
        }
      }, 500)
    },
    startDate: {
      get() {
        return this.ReferralPageFilters.dates.from;
      },
      set(value) {
        this.setReferralPageFromDate(value).then(() => {
          this.$emit('change');
        });
      }
    },
    endDate: {
      get() {
        return this.ReferralPageFilters.dates.to;
      },
      set(value) {
        this.setReferralPageToDate(value).then(() => {
          this.$emit('change');
        });
      }
    },
    orderedOwners: function() {
      let owners = _.orderBy(this.OwnersList, 'full_name');
      owners.push({
        id: null,
        full_name: 'Not Assigned',
        roles: []
      });
      return owners;
    },
    orderedStatuses: function() {
      return orderBy(this.EnquiryStatuses, 'name');
    },
    prettyStartDate: function() {
      return isNull(this.startDate) ? null : DateTime.fromISO(this.startDate).toLocaleString();
    },
    prettyEndDate: function() {
      return isNull(this.endDate) ? null : DateTime.fromISO(this.endDate).toLocaleString();
    },
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    }
  },
  methods: {
    ...mapActions([
      'addReferralEnquiryStatusFilter',
      'addReferralOwnerFilter',
      'getRegistrationReferrerList',
      'removeReferralEnquiryStatusFilter',
      'removeReferralOwnerFilter',
      'setReferralFilters',
      'setReferralPageFromDate',
      'setReferralPageFundingMaximum',
      'setReferralPageFundingMinimum',
      'setReferralPageToDate',
      'toggleReferralPageFilter'
    ]),
    currency(value) {
      const intValue = typeof value === 'string' ? parseInt(value.replace(/[^\d.]/g, '')) : value;

      return intValue > 0
        ? intValue.toLocaleString({
            style: 'currency',
            currency: 'GBP',
            currencyDisplay: 'symbol',
            minimumSignificantDigits: 0,
            maximumSignificantDigits: 0
          })
        : value;
    },
    toggleFilter(filter, secondaryFilter) {
      console.log('first filter: ' + filter + ' secondary filter: ' + secondaryFilter);
      if (typeof secondaryFilter !== 'undefined' && this.ReferralPageFilters[secondaryFilter]) {
        this.toggleReferralPageFilter(secondaryFilter);
      }
      this.toggleReferralPageFilter(filter).then(() => {
        this.$emit('change');
      });
    },
    toggleEnquiryStatusFilter(status) {
      if (this.ReferralPageFilters.enquiryStatuses.includes(status.id)) {
        this.removeReferralEnquiryStatusFilter(status);
      } else {
        this.addReferralEnquiryStatusFilter(status);
      }
      this.$emit('change');
    },
    toggleOwnerFilter(owner) {
      if (this.ReferralPageFilters.owners.includes(owner.id)) {
        this.removeReferralOwnerFilter(owner);
      } else {
        this.addReferralOwnerFilter(owner);
      }
      this.$emit('change');
    }
  },
  filters: {
    titleCase: function(string) {
      return words(string)
        .map(word => (word.length !== 3 ? capitalize(word) : word))
        .reduce((carry, word) => carry + ' ' + word, '');
    }
  },
  created() {
    this.getRegistrationReferrerList();
  }
};
</script>
